<div class="explore-page">
  <app-normal-navbar></app-normal-navbar>

  <main class="explore-container">
    <!-- Hero Header -->
    <header class="explore-hero">
      <h1 class="hero-title">{{ pageTitle }}</h1>

      <!-- Search Input Bar -->
      <div class="explore-search-bar">
        <div class="search-input-wrapper">
          <svg class="search-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
            stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="11" cy="11" r="8"></circle>
            <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
          </svg>
          <input type="text" class="search-input-field" [placeholder]="searchPlaceholder" [value]="searchQuery"
            (input)="onSearchInput($any($event.target).value)" (keyup.enter)="submitSearch()" aria-label="Search" />
          <button *ngIf="searchQuery" type="button" class="search-clear-btn" (click)="clearSearch()"
            aria-label="Clear search" title="Clear search">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>
        <button type="button" class="search-action-btn" (click)="submitSearch()">
          <span>{{ languageService.t('search') }}</span>
        </button>
      </div>

      <!-- Active Search Banner -->
      <div class="search-active-banner" *ngIf="isSearching">
        <span class="search-results-label">
          Searching {{ mediaLabel }} for: <strong>"{{ activeSearchQuery }}"</strong>
          <span class="results-count" *ngIf="!isLoading">({{ totalSearchResults }} {{ totalSearchResults === 1 ?
            'result' : 'results' }} found)</span>
        </span>
        <button type="button" class="banner-clear-link" (click)="clearSearch()">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
          {{ languageService.t('clearSearch') }}
        </button>
      </div>

      <!-- Category Filter Pills -->
      <nav class="category-pills" aria-label="Subcategory navigation" *ngIf="!isSearching">
        <a *ngFor="let sub of currentSubCategories" [routerLink]="sub.route" class="pill-btn"
          [class.active]="category === sub.id" (click)="onTabClick(sub)">
          {{ sub.label }}
        </a>
      </nav>
    </header>

    <!-- Content Grid -->
    <section class="explore-content">
      <!-- Error State -->
      <div class="explore-error" *ngIf="!isLoading && hasError">
        <p>Unable to load titles right now. Please try again.</p>
        <button class="retry-btn" (click)="fetchData(1)">{{ languageService.t('tryAgain') }}</button>
      </div>

      <!-- Empty State -->
      <div class="explore-empty" *ngIf="!isLoading && !hasError && !items.length">
        <div class="empty-icon-wrap">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" stroke-width="1.5">
            <circle cx="11" cy="11" r="8"></circle>
            <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
          </svg>
        </div>
        <p *ngIf="isSearching">No {{ mediaLabel }} found matching <strong>"{{ activeSearchQuery }}"</strong>.</p>
        <p *ngIf="!isSearching">No titles found in this category.</p>
        <button *ngIf="isSearching" class="retry-btn" (click)="clearSearch()">{{ languageService.t('clearSearch')
          }}</button>
      </div>

      <!-- Grid of Common Media Cards & Skeletons -->
      <div class="cards-grid" *ngIf="isLoading || items.length">
        <!-- Initial Loading Skeletons (20 cards) -->
        <ng-container *ngIf="isLoading">
          <app-card-skeleton *ngFor="let _ of initialSkeletons" [mediaType]="mediaType"></app-card-skeleton>
        </ng-container>

        <!-- Actual Loaded Media Cards -->
        <ng-container *ngIf="!isLoading">
          <app-media-card *ngFor="let item of items" [data]="item" [mediaType]="mediaType"></app-media-card>

          <!-- Infinite Scroll Skeletons (Appended at bottom while loading next page) -->
          <ng-container *ngIf="isLoadingMore">
            <app-card-skeleton *ngFor="let _ of moreSkeletons" [mediaType]="mediaType"></app-card-skeleton>
          </ng-container>
        </ng-container>
      </div>

      <!-- Scroll Sentinel for IntersectionObserver -->
      <div #scrollSentinel class="scroll-sentinel"></div>

      <!-- End of Results -->
      <div class="scroll-end" *ngIf="!isLoading && items.length && currentPage >= totalPages">
        <span>{{ languageService.t('endOfResults') }}</span>
      </div>
    </section>
  </main>

  <app-footer></app-footer>
</div>